'use client'

import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

type RadioItem = {
  value: string
  label: React.ReactNode
}

type Props = {
  onFilterChange: (value: string) => void
  items?: RadioItem[]
  defaultValue?: string
  value?: string
}

export const FilterRadio = ({
  onFilterChange,
  items,
  defaultValue,
  value,
}: Props) => {
  // Default items if none are provided
  const defaultItems: RadioItem[] = [
    { value: 'newest', label: 'Mới nhất' },
    { value: 'price-asc', label: 'Giá thấp đến cao' },
    { value: 'price-desc', label: 'Giá cao đến thấp' },
    { value: 'bestseller', label: 'Bán chạy' },
  ]

  // Use provided items or fall back to default items
  const radioItems = items || defaultItems

  return (
    <RadioGroup
      name='filter-radio-group'
      value={value}
      defaultValue={defaultValue}
      onValueChange={(value: string) => onFilterChange(value)}
    >
      {radioItems.map((item) => (
        <RadioGroupItem key={item.value} value={item.value}>
          {item.label}
        </RadioGroupItem>
      ))}
    </RadioGroup>
  )
}
